import { showSearchExpander, hideSearchExpander, testSearchExpander, focusState, removeFocusState } from './components/searchExpander.js';

document.getElementById('search-arrow').addEventListener('click', testSearchExpander);
document.getElementById('search-input').addEventListener('focus', showSearchExpander);
document.getElementById('search-overlay').addEventListener('click', hideSearchExpander);

import { showMenuExpander, hideMenuExpander, hideMenuExpanderSpacer, hideMenuContent, showMenuContentVyrtych, showMenuContentProdukty, showMenuContentSektory, hideMenuContentVyrtych, hideMenuContentProdukty, hideMenuContentSektory } from './components/menuExpander.js';

const menuItemsShow = document.querySelectorAll('.menu-item-vyrtych, .menu-item-produkty, .menu-item-sektory, #menu-expander, #menu-expander-spacer');
const menuItemsLeave = document.querySelectorAll('#search-wrapper, #menu-overlay, .footer, .menu-item-basic');

const menuItemVyrtych = document.querySelectorAll('.menu-item-vyrtych');
const menuItemProdukty = document.querySelectorAll('.menu-item-produkty');
const menuItemSektory = document.querySelectorAll('.menu-item-sektory');

menuItemsShow.forEach(item => {
    item.addEventListener('mouseenter', showMenuExpander);
});

menuItemsLeave.forEach(item => {
    item.addEventListener('mouseenter', hideMenuExpander);
    item.addEventListener('mouseenter', hideMenuContent);
    item.addEventListener('mouseenter', hideMenuExpanderSpacer);
});

menuItemsShow.forEach(item => {
    item.addEventListener('mouseenter', showMenuExpander);
});

menuItemVyrtych.forEach(item => {
    item.addEventListener('mouseenter', () => {
        hideMenuContentSektory();
        hideMenuContentProdukty();
        showMenuContentVyrtych();
    });
});

menuItemProdukty.forEach(item => {
    item.addEventListener('mouseenter', () => {
        hideMenuContentVyrtych();
        hideMenuContentSektory();
        showMenuContentProdukty();
    });
});

menuItemSektory.forEach(item => {
    item.addEventListener('mouseenter', () => {
        hideMenuContentVyrtych();
        hideMenuContentProdukty();
        showMenuContentSektory();
    });
});

// Add scroll event listener to hide the overlay after scrolling 1000px
window.addEventListener('scroll', () => {
    if (window.scrollY >= 5) {
        hideSearchExpander();
        hideMenuExpander();
        removeFocusState();
    }
});

import { toggleExpandableContent} from './components/accordionExpander.js';

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", toggleExpandableContent);
});

import { toggleExpandableContentDownloads } from './components/accordionExpanderDownloads.js';

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", toggleExpandableContentDownloads);
});


import { toggleSpecExpander } from './components/specExpander.js';

document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", toggleSpecExpander);
});

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.filter-accordion a');
    const anchors = document.querySelectorAll('.hide-this');

    // Initially show all anchors
    anchors.forEach(anchor => {
        anchor.style.display = 'block';
        anchor.classList.add('top-10');
    });

    function updateVisibility() {
        const activeClasses = new Set();

        // Collect classes from all clicked buttons
        buttons.forEach(btn => {
            if (btn.classList.contains('clicked')) {
                const btnClasses = Array.from(btn.classList).filter(className => className.startsWith('pill-'));
                btnClasses.forEach(cls => activeClasses.add(cls));
            }
        });

        // Determine which anchors should be visible
        const visibleAnchors = new Set(anchors);
        anchors.forEach(anchor => {
            const anchorClasses = Array.from(anchor.classList).filter(className => className.startsWith('pill-'));
            const shouldShow = Array.from(activeClasses).every(activeClass => anchorClasses.includes(activeClass));
            if (shouldShow || activeClasses.size === 0) {
                anchor.style.display = 'block';
                anchor.classList.add('top-10');
                visibleAnchors.add(anchor);
            } else {
                anchor.style.display = 'none';
                anchor.classList.remove('top-10');
                visibleAnchors.delete(anchor);
            }
        });

        // Collect all classes present in visible anchors
        const visibleClasses = new Set();
        visibleAnchors.forEach(anchor => {
            Array.from(anchor.classList).filter(className => className.startsWith('pill-')).forEach(cls => visibleClasses.add(cls));
        });

        // Update 'unclickable' class for buttons based on visibleClasses
        buttons.forEach(btn => {
            const btnClass = Array.from(btn.classList).find(className => className.startsWith('pill-'));
            if (visibleClasses.has(btnClass)) {
                btn.classList.remove('unclickable');
            } else {
                btn.classList.add('unclickable');
            }
        });
    }

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // If button has 'unclickable' class, do nothing
            if (button.classList.contains('unclickable')) {
                return;
            }

            // Toggle 'clicked' class on the clicked button
            button.classList.toggle('clicked');
            updateVisibility();
        });
    });

    updateVisibility(); // Initial update to set the correct visibility on page load
});

document.addEventListener('DOMContentLoaded', () => {
    const countrySelector = document.getElementById('country');
    const allKontaktContainers = document.querySelectorAll('.kontakty-posts-container');

    // Function to update visibility of kontakt-zeme elements within each container
    function updateVisibility() {
        const selectedValue = countrySelector.value;

        allKontaktContainers.forEach(container => {
            const allKontaktZemeElements = container.querySelectorAll('.kontakt-zeme');

            allKontaktZemeElements.forEach(element => {
                if (selectedValue === 'vsechny') {
                    // Show all elements if "vsechny" is selected
                    element.style.display = 'block';
                } else {
                    // Check if element has the class "kontakt-zeme-*"
                    if (element.classList.contains(`kontakt-zeme-${selectedValue}`)) {
                        element.style.display = 'block';
                    } else {
                        element.style.display = 'none';
                    }
                }
            });
        });
    }

    // Add event listener to the dropdown menu
    countrySelector.addEventListener('change', updateVisibility);

    // Initialize visibility on page load
    updateVisibility();
});


// Assuming you are using ES6 modules with Vite
document.addEventListener('DOMContentLoaded', () => {
    const categoryPills = document.querySelectorAll('.kontakt-category-pills a');
    const allKontaktTaxContainers = document.querySelectorAll('[class*="kontakt-tax-"]');
    const vsechnyKategoriePill = document.querySelector('[data-category="vsechny-kategorie"]');

    // Function to handle category filtering
    function handleCategoryClick(event) {
        event.preventDefault();

        // Remove "clicked" class from all pills
        categoryPills.forEach(pill => pill.classList.remove('clicked'));

        // Add "clicked" class to the clicked pill
        this.classList.add('clicked');

        // Get the selected category slug from the data-category attribute
        const selectedCategory = this.getAttribute('data-category');

        // Hide all containers with "kontakt-tax" class
        allKontaktTaxContainers.forEach(container => {
            // Check if the container has the class for the selected category
            if (selectedCategory === 'vsechny-kategorie' || container.classList.contains(`kontakt-tax-${selectedCategory}`)) {
                container.style.display = 'block';
            } else {
                container.style.display = 'none';
            }
        });
    }

    // Add click event listeners to each category pill
    categoryPills.forEach(pill => {
        pill.addEventListener('click', handleCategoryClick);
    });

    // Set "Všechny kategorie" as the default selected category
    if (vsechnyKategoriePill) {
        vsechnyKategoriePill.classList.add('clicked');
        // Trigger click event on page load to show all categories by default
        vsechnyKategoriePill.click();
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const postLinks = document.querySelectorAll('.show-single-post, .show-all-posts');
    const posts = document.querySelectorAll('.technical-post-item');

    postLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const postId = link.getAttribute('data-post-id');
            const isShowAll = link.classList.contains('show-all-posts');

            if (isShowAll) {
                // Show all posts
                posts.forEach(post => {
                    post.style.display = 'block';
                });
            } else {
                // Show only the clicked post
                posts.forEach(post => {
                    if (post.id === postId) {
                        post.style.display = 'block';
                    } else {
                        post.style.display = 'none';
                    }
                });
            }

            // Optionally add active class to the clicked link
            postLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.getElementById('hamburger');
    const fullPageMenu = document.getElementById('full-page-menu');
    const closeButton = document.querySelector('.close-button');
    const menuLinks = document.querySelectorAll('#full-page-menu ul li a');

    hamburger.addEventListener('click', function() {
        fullPageMenu.style.display = 'block';
    });

    closeButton.addEventListener('click', function() {
        fullPageMenu.style.display = 'none';
    });

    menuLinks.forEach(link => {
        link.addEventListener('click', function() {
            fullPageMenu.style.display = 'none';
        });
    });
});


document.addEventListener('DOMContentLoaded', () => {
    const languageToggle = document.getElementById('language-toggle');
    const currentUrl = window.location.href;
    
    const czechSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
            <rect width="20" height="16" fill="#d7141a"/>
            <rect width="20" height="8" fill="#fff"/>
            <path d="M 10,8 0,0 V 16 z" fill="#11457e"/>
        </svg>`;
        
    const englishSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none" id="language-toggle">
                    <mask id="mask0_1986_2278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
                        <rect width="20" height="15" fill="white" />
                    </mask>
                    <g mask="url(#mask0_1986_2278)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V15H20V0H0Z" fill="#2E42A5" />
                        <mask id="mask1_1986_2278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V15H20V0H0Z" fill="white" />
                        </mask>
                        <g mask="url(#mask1_1986_2278)">
                            <mask id="mask2_1986_2278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
                                <rect width="20" height="15" fill="white" />
                            </mask>
                            <g mask="url(#mask2_1986_2278)">
                                <path d="M-2.22705 13.9284L2.17401 15.7897L20.0998 2.02366L22.4212 -0.742266L17.7149 -1.36436L10.4034 4.56781L4.51844 8.5647L-2.22705 13.9284Z" fill="white" />
                                <path d="M-1.62451 15.2325L0.617623 16.3126L21.5876 -0.999216H18.4394L-1.62451 15.2325Z" fill="#F50100" />
                                <path d="M22.2268 13.9284L17.8258 15.7897L-0.100023 2.02366L-2.42148 -0.742266L2.28482 -1.36436L9.59631 4.56781L15.4813 8.5647L22.2268 13.9284Z" fill="white" />
                                <path d="M22.0767 14.8643L19.8345 15.9445L10.9053 8.53236L8.25794 7.70422L-2.64483 -0.732773H0.503387L11.4 7.50397L14.2944 8.49699L22.0767 14.8643Z" fill="#F50100" />
                                <mask id="path-9-inside-1_1986_2278" fill="white">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.361 -1.25H7.63877V5H-1.23291V10H7.63877V16.25H12.361V10H21.2671V5H12.361V-1.25Z" />
                                </mask>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.361 -1.25H7.63877V5H-1.23291V10H7.63877V16.25H12.361V10H21.2671V5H12.361V-1.25Z" fill="#F50100" />
                                <path d="M7.63877 -1.25V-2.5H6.38877V-1.25H7.63877ZM12.361 -1.25H13.611V-2.5H12.361V-1.25ZM7.63877 5V6.25H8.88877V5H7.63877ZM-1.23291 5V3.75H-2.48291V5H-1.23291ZM-1.23291 10H-2.48291V11.25H-1.23291V10ZM7.63877 10H8.88877V8.75H7.63877V10ZM7.63877 16.25H6.38877V17.5H7.63877V16.25ZM12.361 16.25V17.5H13.611V16.25H12.361ZM12.361 10V8.75H11.111V10H12.361ZM21.2671 10V11.25H22.5171V10H21.2671ZM21.2671 5H22.5171V3.75H21.2671V5ZM12.361 5H11.111V6.25H12.361V5ZM7.63877 0H12.361V-2.5H7.63877V0ZM8.88877 5V-1.25H6.38877V5H8.88877ZM-1.23291 6.25H7.63877V3.75H-1.23291V6.25ZM0.0170898 10V5H-2.48291V10H0.0170898ZM7.63877 8.75H-1.23291V11.25H7.63877V8.75ZM8.88877 16.25V10H6.38877V16.25H8.88877ZM12.361 15H7.63877V17.5H12.361V15ZM11.111 10V16.25H13.611V10H11.111ZM21.2671 8.75H12.361V11.25H21.2671V8.75ZM20.0171 5V10H22.5171V5H20.0171ZM12.361 6.25H21.2671V3.75H12.361V6.25ZM11.111 -1.25V5H13.611V-1.25H11.111Z" fill="white" mask="url(#path-9-inside-1_1986_2278)" />
                            </g>
                        </g>
                    </g>
                </svg>`;
        
    const germanSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 5 3">
	<desc>Flag of Germany</desc>
	<rect id="black_stripe" width="5" height="3" y="0" x="0" fill="#000"/>
	<rect id="red_stripe" width="5" height="2" y="1" x="0" fill="#D00"/>
	<rect id="gold_stripe" width="5" height="1" y="2" x="0" fill="#FFCE00"/>
</svg>`;
    
        const spanishSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16">
<rect width="20" height="16" fill="#c60b1e"/>
<rect width="20" height="8" fill="#ffc400" y="4"/>
</svg>>`;
    
    const frenchSVG =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" width="20" height="16"><path fill="#CE1126" d="M0 0h900v600H0"/><path fill="#fff" d="M0 0h600v600H0"/><path fill="#002654" d="M0 0h300v600H0"/></svg>';
    


    // Function to check the current language and update the SVG
    function updateLanguageIcon() {
        if (currentUrl.includes('/de')) {
            languageToggle.innerHTML = germanSVG;
        } else if (currentUrl.includes('/en')) {
            languageToggle.innerHTML = englishSVG;
        } else if (currentUrl.includes('/es')) {
            languageToggle.innerHTML = spanishSVG;
            } else if (currentUrl.includes('/fr')) {
            languageToggle.innerHTML = frenchSVG;
        }
        
        else {
            languageToggle.innerHTML = czechSVG;
        }
    }

    updateLanguageIcon();
});

document.addEventListener('DOMContentLoaded', () => {
    const languageToggle = document.getElementById('language-toggle');
    const dropdownContent = document.querySelector('.dropdown-content');
    const dropdownItems = document.querySelectorAll('.dropdown-item');

    // Toggle the dropdown visibility
    languageToggle.addEventListener('click', () => {
        dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
    });

    // Handle item selection
    dropdownItems.forEach(item => {
        item.addEventListener('click', () => {
            const selectedLanguage = item.getAttribute('data-value');
            let currentUrl = new URL(window.location.href);
            let newUrl;

            // Construct the new URL using the post ID and language code
            if (selectedLanguage !== 'cz') {
                newUrl = `${currentUrl.origin}/${selectedLanguage}/?p=${currentPostId}`;
            } else {
                // Default language doesn't need a language code in the URL
                newUrl = `${currentUrl.origin}/?p=${currentPostId}`;
            }

            // Redirect to the new URL
            window.location.href = newUrl;
        });
    });

    // Close the dropdown if clicked outside
    document.addEventListener('click', (event) => {
        if (!event.target.closest('#language-icon-small') && !event.target.closest('#custom-language-selector')) {
            dropdownContent.style.display = 'none';
        }
    });
});


document.addEventListener('DOMContentLoaded', () => {
    const languageToggle = document.getElementById('language-toggle-2');
    const currentUrl = window.location.href;
    
    const czechSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
            <rect width="20" height="16" fill="#d7141a"/>
            <rect width="20" height="8" fill="#fff"/>
            <path d="M 10,8 0,0 V 16 z" fill="#11457e"/>
        </svg>`;
        
    const englishSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                    <mask id="mask0_1986_2278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
                        <rect width="20" height="15" fill="white" />
                    </mask>
                    <g mask="url(#mask0_1986_2278)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V15H20V0H0Z" fill="#2E42A5" />
                        <mask id="mask1_1986_2278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V15H20V0H0Z" fill="white" />
                        </mask>
                        <g mask="url(#mask1_1986_2278)">
                            <mask id="mask2_1986_2278" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="15">
                                <rect width="20" height="15" fill="white" />
                            </mask>
                            <g mask="url(#mask2_1986_2278)">
                                <path d="M-2.22705 13.9284L2.17401 15.7897L20.0998 2.02366L22.4212 -0.742266L17.7149 -1.36436L10.4034 4.56781L4.51844 8.5647L-2.22705 13.9284Z" fill="white" />
                                <path d="M-1.62451 15.2325L0.617623 16.3126L21.5876 -0.999216H18.4394L-1.62451 15.2325Z" fill="#F50100" />
                                <path d="M22.2268 13.9284L17.8258 15.7897L-0.100023 2.02366L-2.42148 -0.742266L2.28482 -1.36436L9.59631 4.56781L15.4813 8.5647L22.2268 13.9284Z" fill="white" />
                                <path d="M22.0767 14.8643L19.8345 15.9445L10.9053 8.53236L8.25794 7.70422L-2.64483 -0.732773H0.503387L11.4 7.50397L14.2944 8.49699L22.0767 14.8643Z" fill="#F50100" />
                                <mask id="path-9-inside-1_1986_2278" fill="white">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.361 -1.25H7.63877V5H-1.23291V10H7.63877V16.25H12.361V10H21.2671V5H12.361V-1.25Z" />
                                </mask>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.361 -1.25H7.63877V5H-1.23291V10H7.63877V16.25H12.361V10H21.2671V5H12.361V-1.25Z" fill="#F50100" />
                                <path d="M7.63877 -1.25V-2.5H6.38877V-1.25H7.63877ZM12.361 -1.25H13.611V-2.5H12.361V-1.25ZM7.63877 5V6.25H8.88877V5H7.63877ZM-1.23291 5V3.75H-2.48291V5H-1.23291ZM-1.23291 10H-2.48291V11.25H-1.23291V10ZM7.63877 10H8.88877V8.75H7.63877V10ZM7.63877 16.25H6.38877V17.5H7.63877V16.25ZM12.361 16.25V17.5H13.611V16.25H12.361ZM12.361 10V8.75H11.111V10H12.361ZM21.2671 10V11.25H22.5171V10H21.2671ZM21.2671 5H22.5171V3.75H21.2671V5ZM12.361 5H11.111V6.25H12.361V5ZM7.63877 0H12.361V-2.5H7.63877V0ZM8.88877 5V-1.25H6.38877V5H8.88877ZM-1.23291 6.25H7.63877V3.75H-1.23291V6.25ZM0.0170898 10V5H-2.48291V10H0.0170898ZM7.63877 8.75H-1.23291V11.25H7.63877V8.75ZM8.88877 16.25V10H6.38877V16.25H8.88877ZM12.361 15H7.63877V17.5H12.361V15ZM11.111 10V16.25H13.611V10H11.111ZM21.2671 8.75H12.361V11.25H21.2671V8.75ZM20.0171 5V10H22.5171V5H20.0171ZM12.361 6.25H21.2671V3.75H12.361V6.25ZM11.111 -1.25V5H13.611V-1.25H11.111Z" fill="white" mask="url(#path-9-inside-1_1986_2278)" />
                            </g>
                        </g>
                    </g>
                </svg>`;
        
    const germanSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 5 3">
	<desc>Flag of Germany</desc>
	<rect id="black_stripe" width="5" height="3" y="0" x="0" fill="#000"/>
	<rect id="red_stripe" width="5" height="2" y="1" x="0" fill="#D00"/>
	<rect id="gold_stripe" width="5" height="1" y="2" x="0" fill="#FFCE00"/>
</svg>`;
       const spanishSVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16">
<rect width="20" height="16" fill="#c60b1e"/>
<rect width="20" height="8" fill="#ffc400" y="4"/>
</svg>`;
    
    const frenchSVG =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" width="20" height="16"><path fill="#CE1126" d="M0 0h900v600H0"/><path fill="#fff" d="M0 0h600v600H0"/><path fill="#002654" d="M0 0h300v600H0"/></svg>';
    
    // Function to check the current language and update the SVG
    function updateLanguageIcon() {
        if (currentUrl.includes('/de')) {
            languageToggle.innerHTML = germanSVG;
        } else if (currentUrl.includes('/en')) {
            languageToggle.innerHTML = englishSVG;
        } else if (currentUrl.includes('/es')) {
            languageToggle.innerHTML = spanishSVG;
        } else if (currentUrl.includes('/fr')) {
            languageToggle.innerHTML = frenchSVG;
        }
        else {
            languageToggle.innerHTML = czechSVG;
        }
    }

    updateLanguageIcon();
});

document.addEventListener('DOMContentLoaded', () => {
    const languageToggle = document.getElementById('language-toggle-2');
    const dropdownContent = document.querySelector('.dropdown-content-2');
    const dropdownItems = document.querySelectorAll('.dropdown-item-2');

    // Toggle the dropdown visibility
    languageToggle.addEventListener('click', () => {
        dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
    });

    // Handle item selection
    dropdownItems.forEach(item => {
        item.addEventListener('click', () => {
            const selectedLanguage = item.getAttribute('data-value');
            let currentUrl = new URL(window.location.href);
            let newUrl;

            // Construct the new URL using the post ID and language code
            if (selectedLanguage !== 'cz') {
                newUrl = `${currentUrl.origin}/${selectedLanguage}/?p=${currentPostId}`;
            } else {
                // Default language doesn't need a language code in the URL
                newUrl = `${currentUrl.origin}/?p=${currentPostId}`;
            }

            // Redirect to the new URL
            window.location.href = newUrl;
        });
    });

    // Close the dropdown if clicked outside
    document.addEventListener('click', (event) => {
        if (!event.target.closest('#language-icon-small-2') && !event.target.closest('#custom-language-selector-2')) {
            dropdownContent.style.display = 'none';
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    // Find all buttons with the class "reagovat-button"
    const buttons = document.querySelectorAll('.reagovat-button');
    const lightbox = document.getElementById('slcf-lightbox');
    const lightboxTitle = document.getElementById('slcf-lightbox-title');

    buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();

            // Get the post ID and title from the button's attributes
            const postID = button.id;
            const postTitle = button.getAttribute('data-title') || 'Default Title';

            // Set the title in the lightbox
            lightboxTitle.textContent = postTitle;

            // Set the position field in the Contact Form 7 with the post title
            const positionField = document.querySelector('input[name="position"]');
            if (positionField) {
                positionField.value = postTitle;
            }

            // Show the lightbox
            lightbox.style.display = 'flex';
        });
    });

    // Hide the lightbox when clicking outside the content
    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) {
            lightbox.style.display = 'none';
        }
    });
});






    document.addEventListener("DOMContentLoaded", function() {
        // Create an overlay div
        const overlay = document.createElement("div");
        overlay.className = "image-overlay";
        document.body.appendChild(overlay);

        // Function to show the overlay
        function showOverlay(event) {
            const description = event.target.getAttribute("data-description");
            if (description) {
                overlay.textContent = description;
                overlay.style.display = "block";
                overlay.style.top = event.pageY + 10 + "px";
                overlay.style.left = event.pageX + 10 + "px";
            }
        }

        // Function to hide the overlay
        function hideOverlay() {
            overlay.style.display = "none";
        }

        // Attach event listeners to each image with the class 'image-with-overlay'
        document.querySelectorAll(".image-with-overlay").forEach(function(img) {
            img.addEventListener("mouseover", showOverlay);
            img.addEventListener("mousemove", showOverlay);
            img.addEventListener("mouseout", hideOverlay);
        });
    });